import { render, staticRenderFns } from "./BuyConfirm.vue?vue&type=template&id=a67182c2"
import script from "./BuyConfirm.vue?vue&type=script&lang=js"
export * from "./BuyConfirm.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./BuyConfirm.vue?vue&type=style&index=0&id=a67182c2&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports